;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"
import SecondaryButtonTitle from "../SecondaryButtonTitle"
import type { MouseEventHandler } from "react"

const HEADER_STYLE =
  "font-bebas text-[28px] min-[450px]:text-[60px] min-[450px]:tracking-1 tracking-5 text-black"
const HEADER_CONTAINER_STYLE = "flex justify-between pt-[20px] "

function SignUpLoginHeader({
  text,
  secondaryOptionText,
  secondaryOptionOnClick,
  secondaryOptionHref,
}: {
  text: string
  secondaryOptionText?: string
  secondaryOptionOnClick?: MouseEventHandler<HTMLButtonElement>
  secondaryOptionHref?: string
}) {
  return secondaryOptionText ? (
    <div className={HEADER_CONTAINER_STYLE}>
      <h1 className={HEADER_STYLE}>{text}</h1>
      <SecondaryButtonTitle
        text={secondaryOptionText}
        href={secondaryOptionHref}
        onClick={secondaryOptionOnClick}
      />
    </div>
  ) : (
    <div className={HEADER_CONTAINER_STYLE}>
      <h1 className={HEADER_STYLE}>{text}</h1>
    </div>
  )
}

export default SignUpLoginHeader
